<template>
  <div class="property" id="property">
    <!-- 星润物业 -->
    <div
      class="header-img"
      :style="{ backgroundImage: 'url(' + propertyList.thumb + ')' }"
    ></div>
    <div class="content">
      <!-- 星润物业文字说明 -->
      <div class="one">
        <div class="one-content">
          <!-- <span class="one-title">{{propertyList.title1}}</span>
          <p class="one-subtitle">{{propertyList.sub_title1}}</p>-->
          <span class="one-title">星润物业</span>
          <div class="subtitle-box">
            <div class="one-subtitle">
              <p class="box-one">{{ propertyList.title1 }}</p>
              <!-- <p class="box-two">{{propertyList.sub_title1}}</p> -->
            </div>
          </div>
          <p class="one-desc" v-html="propertyList.context1">
            {{ propertyList.context1 }}
          </p>
          <img :src="propertyList.pic1" />
          <p class="one-desc">
            公司在职员工200余人，管理团队主要由行业资深职业经理人及各类专业人才构成，在职员工大专以上学历占50%以上（中高级职称15%），公司依托良好的人才优势，秉承物业管理“精细化服务、专业化管理”理念，持续超越客户不断增长的期望，为嘉华地产后续开发项目提供更加专业优质的物业管理服务。
          </p>
        </div>
      </div>
      <div class="img-two">
        <div class="img-two-content">
          <!-- <img :src="propertyList.pic2" /> -->
          <!-- <span class="three-title">XINGRUN COURSE</span> -->
          <p class="three-subtitle">星润物业大事记</p>
          <img :src="propertyList.pic2" />
        </div>
      </div>

      <div class="img-three">
        <!-- <span class="three-title">PROFESSIONAL TEAM</span> -->
        <p class="three-subtitle">专业团队，持续超越</p>
        <p class="three-img-desc">
          公司管理团队，由知名品牌物业的资深职业经理人构成。专业化、职业化、年轻化团队，适应现代高端物业需求，提供持续超越客户期待的管理服务，也为集团整体品牌打造，奠定坚实基础。
        </p>
        <div class="corporate">
          <div class="corporate-content">
            <!-- <p class="three-subtitle">形象照片</p> -->
            <ul>
              <li>
                <img src="../../assets/product/img1.png" />
              </li>
              <li>
                <img src="../../assets/product/img2.png" />
              </li>
              <li>
                <img src="../../assets/product/img3.png" />
              </li>
            </ul>
          </div>
        </div>
        <!-- <img :src="propertyList.pic3" /> -->
      </div>
      <div class="two">
        <div class="two-content">
          <!-- <span class="two-title">{{propertyList.sub_title3}}</span> -->
          <p class="two-subtitle">{{ propertyList.title3 }}</p>
          <p class="two-desc" v-html="propertyList.context4">
            {{ propertyList.context4 }}
          </p>
        </div>
      </div>
      <div class="three">
        <div class="three-content">
          <!-- <span class="three-title">SERVICE ITEMS</span> -->
          <p class="three-subtitle">{{ propertyList.titl4 }}</p>
          <ul>
            <li v-for="(item, index) in fivelist" :key="index">
              <img :src="item.thumb" />
              <span>{{ item.title }}</span>
            </li>
          </ul>
        </div>
      </div>
      <div class="book">
        <div class="book-content">
          <p class="three-subtitle">荣誉证书</p>
          <ul>
            <li>
              <img src="../../assets/product/book1.png" class="book-img" />
            </li>
            <li>
              <img src="../../assets/product/book2.png" class="book-img" />
            </li>
            <li>
              <img src="../../assets/product/book3.png" class="book-img" />
            </li>
            <!--<li>-->
              <!--<img src="../../assets/product/xiju4.png" class="book-img" />-->
            <!--</li>-->
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      fivelist: [],
      propertyList: {},
      imgindex: 4,
      animate: false
    };
  },
  created() {
    this.getfivelist();
    this.getProperty();
  },
  methods: {
    getfivelist() {
      this.axios
        .get("https://admin.jsdkgjt.com/wp-json/product/list/property")
        .then(res => {
          this.fivelist = res.data;
        });
    },
    getProperty() {
      this.axios.get("https://admin.jsdkgjt.com/wp-json/page/271").then(res => {
        this.propertyList = res.data[0];
      });
    }
  }
};
</script>
<style scoped>
.property {
  background-color: #f5f5f5;
  min-height: 88vh;
}
.banner-img {
  height: 84.84vh;
  width: 100%;
}
img {
  max-width: 100%;
  display: block;
}
.header-img {
  height: calc(100vh - 140px);
  width: 100%;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}
.content {
  background-color: #fff;
}
.one,
.three {
  padding: 70px 0;
  background-color: #ffffff;
}
.one-content {
  width: 1000px;
  margin: 0 auto;
  text-align: center;
}
.two-content,
.three-content {
  width: 1000px;
  margin: 0 auto;
  text-align: center;
}
.one-content img {
  max-width: 100%;
}
.three-title {
  font-size: 16px;
  color: #666;
}
.three-subtitle {
  font-size: 20px;
  font-weight: 600;
  color: #333;
  padding: 10px 0;
  position: relative;
}
.three-subtitle::after {
  position: absolute;
  bottom: 0;
  width: 69px;
  height: 2px;
  background-color: #02b171;
  content: "";
  left: 50%;
  transform: translateX(-50%);
}
.three-subtitle::before {
  position: absolute;
  bottom: 0;
  width: 176px;
  height: 1px;
  background-color: #dedede;
  content: "";
  left: 50%;
  transform: translateX(-50%);
}
.one-title {
  display: inline-block;
  color: #02b171;
  position: relative;
  font-size: 34px;
  font-weight: bold;
}
.one-title span {
  padding-left: 20px;
  font-size: 18px;
}
.subtitle-box {
  display: block;
  width: 100%;
}
.one-subtitle {
  border: 1px solid #02b171;
  border-left: none;
  border-right: none;
  color: #02b171;
  padding: 20px 40px;
  margin-top: 30px;
  display: inline-block;
}
.one-subtitle .box-one {
  font-size: 28px;
  letter-spacing: 13px;
}
.one-subtitle .box-two {
  font-size: 17px;
}
.one-desc {
  font-size: 16px;
  color: #666;
  padding-top: 20px;
  padding-bottom: 30px;
  line-height: 28px;
}
.three-img-desc {
  font-size: 16px;
  color: #666;
  padding-top: 20px;
  padding-bottom: 30px;
  line-height: 28px;
  width: 50%;
  margin: 0 auto;
}
.two {
  background-image: url("../../assets/product/xingrunwuye_3.png");
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  padding-top: 70px;
  width: 1000px;
  background-color: #fff;
  margin: 0 auto;
}
.two-content {
  width: 1000px;
  margin: 0 auto;
  text-align: center;
  color: #fff;
  padding-bottom: 140px;
}
.two-title {
  font-size: 16px;
}
.two-subtitle {
  font-size: 20px;
  position: relative;
  padding-bottom: 10px;
  line-height: 32px;
}
.two-subtitle::after {
  position: absolute;
  bottom: 0;
  width: 69px;
  height: 2px;
  background-color: #fff;
  content: "";
  left: 50%;
  transform: translateX(-50%);
}
.two-subtitle::before {
  position: absolute;
  bottom: 0;
  width: 176px;
  height: 1px;
  background-color: #fff;
  content: "";
  left: 50%;
  transform: translateX(-50%);
}
.two-desc {
  padding: 20px 0;
  font-size: 16px;
  line-height: 28px;
  width: 50%;
  display: block;
  margin: 0 auto;
}
.three ul {
  overflow: hidden;
  margin-top: 50px;
}
.three ul li {
  list-style: none;
  width: 33.33333%;
  float: left;
  margin-bottom: 40px;
}
.three li img {
  width: 247px;
  height: 267px;
  margin: 0 auto;
  padding-bottom: 20px;
}
.three li span {
  font-size: 18px;
  color: #02b171;
}
.img-two {
  background-color: #ededed;
  text-align: center;
  padding: 60px 0;
}
.img-two-content {
  width: 1000px;
  margin: 0 auto;
  position: relative;
}
.events-wrapper {
  margin-top: 92px;
}
.img-three {
  background-color: #fff;
  width: 1000px;
  margin: 0 auto;
  text-align: center;
  padding: 60px 0;
}
.img-two img,
.img-three img {
  display: block;
  margin: 0 auto;
}
.img-two img {
  padding-top: 20px;
}
.cd-timeline-navigation li {
  list-style: none;
  display: inline-block;
}
.cd-timeline-navigation li a {
  padding: 12px;
  background-color: #fff;
  color: #02b171;
  line-height: 7px;
  position: absolute;
  bottom: 14.5%;
  z-index: 3;
}
.cd-timeline-navigation li a.prev {
  left: 0;
}
.cd-timeline-navigation li a.next {
  right: 0;
}
.events-wrapper {
  position: relative;
  height: 100%;
  overflow: hidden;
}
.events {
  position: relative;
  z-index: 1;
  -webkit-transition: -webkit-transform 0.4s;
  -moz-transition: -moz-transform 0.4s;
  transition: transform 0.4s;
  width: 1000px;
  margin-bottom: 70px;
}
.events-line {
  height: 4px;
  background-color: #fff;
  width: 1000px;
  position: absolute;
  z-index: 1;
  top: 53%;
  /* transform: translateY(-50%); */
}
.events ul {
  overflow: hidden;
  display: flex;
  flex-direction: row;
}
.events ul li {
  list-style: none;
  display: inline-block;
  float: left;
  position: relative;
  padding: 0 18px;
}
.events ul li * {
  z-index: 4;
}
.events ul li p {
  font-size: 16px;
}
.events ul.top li::before {
  content: "";
  position: absolute;
  top: 78%;
  left: 50%;
  width: 15px;
  height: 15px;
  background-color: #fff;
  border: 2px solid #02b171;
  border-radius: 100%;
}
.events ul li:nth-child(1) p {
  padding-top: 44px;
}
.events ul li:nth-child(2) p {
  padding-top: 66px;
}
.events ul li:nth-child(3) p {
  padding-top: 44px;
}
.events ul li:nth-child(4) p {
  padding-top: 66px;
}
.events ul li:nth-child(5) {
  padding-bottom: 30px;
}
.events ul li:nth-child(5) p {
  width: 234px;
}
.events ul li:nth-child(6) p {
  padding-top: 66px;
}
.hide-ul {
  position: absolute;
  bottom: -75px;
  left: 16px;
  font-size: 16px;
}
.events ul.hide-ul li {
  padding: 0 10px;
}
.events ul li:nth-child(1) span {
  padding-top: 20px;
}
.events ul li:nth-child(2) span {
  padding-top: 66px;
}
.events ul li:nth-child(3) span {
  padding-top: 20px;
}
.events ul li:nth-child(4) span {
  padding-top: 66px;
}
.events ul li:nth-child(5) span {
  width: 234px;
}
.events ul li:nth-child(6) span {
  padding-top: 66px;
}
.corporate {
  padding: 0 0 30px 0;
}
.book {
  border-top: 1px solid #ededed;
  padding: 60px 0;
}
.corporate-content,
.book-content {
  text-align: center;
  background-color: #fff;
  width: 1000px;
  margin: 0 auto;
  text-align: center;
}
.corporate ul,
.book ul {
  padding: 0;
  margin: 0;
  display: flex;
  justify-content: space-between;
  list-style: none;
  padding-top: 30px;
  overflow: hidden;
}
.corporate ul li:nth-child(1),
.corporate ul li:nth-child(2),
.book ul li:nth-child(1),
.book ul li:nth-child(2) {
  padding-right: 20px;
}
.corporate ul li,
.book ul li {
  float: left;
}
.corporate ul li img,
.book ul li img {
  height: 210px;
}
</style>
